export const CHECKLISTS = [
    {
        id: "early-spring-nymphing",
        title: "Early Spring Nymphing",
        subtitle: "Cold water, high flows, hungry fish",
        accent: "teal",
        items: [
            "9ft 4–5wt fly rod with floating line",
            "9ft 4X tapered leaders (x2)",
            "Tippet spools: 4X, 5X, 6X",
            "Bead-head nymph box: Pheasant Tails, Hare's Ears, Princes",
            "Split shot assortment (BB–#4)",
            "Strike indicators: yarn + Thingamabobber",
            "Forceps, nippers, and floatant",
            "Wading staff for pushy spring water",
            "Thermometer — watch for the 45°F trigger",
            "Net with rubber bag for cold-stressed fish",
        ],
    },
    {
        id: "backcountry-fly-trek",
        title: "Backcountry Fly Trek",
        subtitle: "Alpine creeks and cutthroat country",
        accent: "coral",
        items: [
            "3wt or 4wt pack rod (4-piece minimum)",
            "Single fly box — dries only: Elk Hair Caddis, Stimulators, Ants",
            "One leader, two tippet spools (5X/6X)",
            "Tenkara rod as ultralight backup",
            "Bear spray on the hip belt",
            "Water filter or purification tabs",
            "Map + compass downloaded offline",
            "First-aid kit with blister care",
            "Rain shell — alpine weather flips fast",
            "Packable net or wet-hand release plan",
        ],
    },
    {
        id: "wading-safety",
        title: "Wading Safety",
        subtitle: "Every trip. No exceptions.",
        accent: "gold",
        items: [
            "Wading belt cinched tight — always",
            "Felt or studded boots matched to the riverbed",
            "Wading staff deployed before crossing",
            "Check the flow gauge before leaving home",
            "Tell someone your beat and return time",
            "Face upstream when crossing current",
            "Unbuckle pack waist strap before deep water",
            "Know your exit points along the stretch",
            "Dry bag for phone and keys",
            "Change of clothes in the truck",
        ],
    },
];

export const TIPS_FLY = [
    {
        num: "01",
        title: "Read the seam, not the river",
        body: "Trout hold where fast water meets slow — the seam. Cast to the cushion line in front of boulders, the tailout below riffles, and the shadow of any undercut bank. Ninety percent of the fish live in ten percent of the water.",
    },
    {
        num: "02",
        title: "Match size before color",
        body: "When a hatch is on, trout key on silhouette and size first. A #16 Elk Hair Caddis in the wrong color outfishes a perfect-color #12. Carry three sizes of your confidence patterns before you carry ten colors.",
    },
    {
        num: "03",
        title: "Mend like you mean it",
        body: "Drag kills more presentations than bad casting. Reach-mend at the cast, then stack-mend upstream as the fly drifts. Your fly should move at the speed of the bubbles — never faster.",
    },
    {
        num: "04",
        title: "Fish the water, not the clock",
        body: "The magic hour is whenever the bugs move. Learn your river's hatches: BWOs on gray afternoons, caddis at dusk, stoneflies when the water hits 50°F. The thermometer beats the watch.",
    },
    {
        num: "05",
        title: "Get closer, cast shorter",
        body: "Most anglers cast too far. A 20-foot drag-free drift you control beats a 50-foot hero cast you can't. Stay low, wade slow, and shorten up — your hookup rate will double.",
    },
    {
        num: "06",
        title: "Set downstream on dries",
        body: "When a trout sips your dry, lift the rod low and toward the bank — a downstream set pulls the fly into the corner of the jaw. A violent overhead strike just launches your fly into the trees behind you.",
    },
];

export const HATCH_GUIDE = [
    { stage: "Nymph", when: "Subsurface, always available", pattern: "Pheasant Tail #14–18", tactic: "Dead-drift under an indicator through riffles" },
    { stage: "Emerger", when: "The vulnerable ascent — trout feed hardest now", pattern: "RS2 or Soft Hackle #16–20", tactic: "Swing just under the surface film" },
    { stage: "Dun (Adult)", when: "Riding the surface to dry wings", pattern: "Parachute Adams #14–18", tactic: "Upstream dead-drift to rising fish" },
    { stage: "Spinner", when: "Egg-laying fall at dusk", pattern: "Rusty Spinner #14–18", tactic: "Fish the flat water below riffles at last light" },
];
